import type { Phrases } from '../../common/Phrases.d';

import React from 'react';
import { useWatch } from 'react-hook-form';
import { useFormContext } from '/react4xp/components/react-hook-form/FormContext';
import { sanitizeHtml } from '/react4xp/shared/sanitizeHtml';
import { Span } from '/react4xp/components/Element';
import { TextField } from '/react4xp/components/react-hook-form/TextField';
import {
	ANONYMOUS_FIELD_NAME,
	ANONYMOUS_WHERE,
} from '../constants';


export const WhereOtherTextField = ({
	whereLabel,
	phrases,
}: {
	phrases: Phrases;
	whereLabel: string;
}): React.JSX.Element => {
	const {
		control,
	} =	useFormContext();
	const where: string = useWatch({ control, name: ANONYMOUS_FIELD_NAME.WHERE}) as string;
	const isOther = where === ANONYMOUS_WHERE.OTHER;
	const localizedOther = sanitizeHtml(phrases['notificationForm.anonymous.whereField.value.other']);
	const whereOtherLabel = isOther
		? localizedOther
		: '';
	return (
		<TextField
			errorSummaryLabel={`${whereLabel} - ${whereOtherLabel}`}
			fullWidth
			label={<Span textSize='lg'>{whereOtherLabel}</Span>}
			name={ANONYMOUS_FIELD_NAME.WHERE_OTHER}
			showIf={({ watch }) => isOther}
		/>
	);
};

